import React from 'react';

import { useForm } from 'components/form';
import { RHP } from 'providers';
import * as Page from 'components/page';

import { useParams } from 'react-router';
import { CorporateStep3EditForm } from './CorporateStep3EditForm';

export function CorporateStep3Edit(props) {
    const { id } = useParams();
    const { vars, putCorpEcosystemRelationship } = props.useRankingCorporate;
    const { ranking } = vars;

    const [changed, setChanged] = React.useState({});

    const relationship = vars.relationships.filter(i => i._id === id)[0];
    if (!relationship) RHP.goBack();

    // Initialize a new form handler
    const form = useForm({
        companyName: relationship.ecosystem.contact.name,
        ...relationship,
        isConfirmed: !!(relationship.company && relationship.company.status === 'confirmed'),
    });

    // Handle form changes
    const onBlur = {
        companyName: () => changed.companyName && setChanged({ companyName: false }),
        year: () => changed.year && setChanged({ year: false }),
    };

    // Handle form changes
    const onChange = {
        companyName: () => setChanged({ companyName: true }),
        year: () => setChanged({ year: true }),
    };

    // Handle form submitions
    const onSubmit = values => {
        const payload = {
            _id: values._id,
            year: values.year,
            programName: values.programName,
            description: values.description,
            linkUrl: values.linkUrl,
            entity: 'company',
            ranking,
        };
        return putCorpEcosystemRelationship(payload)
            .then(() => RHP.push('/ranking/latam/corporate/step3'))
            .catch(() => form.submited());
    };

    const propsForm = { ...props, form, onBlur, onChange, onSubmit };
    return (
        <Page.Page name="CorporateStep3Edit">
            <Page.Title>{props.t('CorporateStep3Edit.title')}</Page.Title>
            <Page.Descr>{props.t('CorporateStep3Edit.descr')}</Page.Descr>
            <CorporateStep3EditForm {...propsForm} relationship={relationship} />
        </Page.Page>
    );
}
export default CorporateStep3Edit;
